const ComingSoon = () => {
  return (
    <main className="h-[calc(100vh-var(--header-height))] flex items-center justify-center px-6">
      <div className="w-full max-w-2xl border rounded-xl p-10 text-center">
        <div className="flex justify-center mb-6">
          <img
            src="https://oloid.cloud/assets/images/website-logo.svg"
            alt="Oloid"
            className="h-10"
          />
        </div>

        <h1 className="text-3xl font-semibold mb-4">
          Oloid Features – Coming Soon
        </h1>

        <p className="text-muted-foreground mb-8">
          We're working hard to bring you something amazing. This feature will
          be available soon. Stay tuned!
        </p>

        <div className="flex justify-center gap-4">
          <a
            href="/"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            Back to Home
          </a>

          <a
            href="/changelog/platform"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-md border border-input hover:bg-accent hover:text-accent-foreground transition-colors"
          >
            View Documentation
          </a>
        </div>

        <footer className="mt-10 text-sm text-muted-foreground">
          © {new Date().getFullYear()} Oloid. All rights reserved.
        </footer>
      </div>
    </main>
  );
};

export default ComingSoon;
